.wordmark {
  font-family: "Crimson Pro", Georgia, serif;
  font-size: var(--survey-font-size-wordmark, 0.75rem);
  font-weight: 300;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #391640;
  opacity: 0.4;
}
